<script>
  // will be changed to be a global component (now used only in friends-addition
  // )

  export default {
    name: 'PromptDialog',

    data: () => ({
      title: '',
      subTitle: '',
      text: '',
      inputText: '',
      inputPlaceholder: '',
      inputRules: '',
      callback: () => {},

      showDialog: false,
    }),

    computed: {
      promptDialog() {
        return this.$store.getters['getPromptDialog'];
      },
    },

    watch: {
      promptDialog() {
        this.showDialog = !!this.promptDialog;

        if (!this.promptDialog) {
          this.callback = () => {};
          return;
        }

        const {
          title,
          subTitle,
          placeholder,
          callback,
          yesText = 'Yes',
          noText = 'No',
          yesVisible = true,
          noVisible = true,
          rules,
        } = this.promptDialog;

        this.title = title;
        this.subTitle = subTitle;
        this.inputPlaceholder = placeholder;
        this.callback = callback;
        this.yesText = yesText;
        this.noText = noText;
        this.yesVisible = yesVisible;
        this.noVisible = noVisible;
        this.inputRules = rules;
      },
    },

    methods: {
      accept() {
        this.callback(this.inputText);
      },
      closeDialog() {
        this.$store.dispatch('hidePromptDialog');
      },
    },
  };
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    max-width="600px"
    content-class="confirm-dialog outlined-modal alert-shadow rounded-borders-5"
    @keydown.esc="closeDialog()"
  >
    <v-card class="prompt-card d-flex flex-column position-relative pt-10 pb-0">
      <v-card-title class="justify-center">
        <span class="white--text font-size-28 font-weight-bold prompt-title">
          {{ title }}
        </span>
      </v-card-title>

      <v-btn icon style="z-index: 2" class="close-button-white" @click="closeDialog">
        <v-icon class="close-icon" color="white">mdi-close</v-icon>
      </v-btn>

      <hr class="mt-1 mb-10" />

      <v-card-text class="white--text text-center font-size-20 font-weight-semi prompt-body px-0">
        <v-text-field
          v-model="inputText"
          :placeholder="inputPlaceholder"
          :rules="inputRules"
          persistent-placeholder
          outlined
          class="formText"
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="d-flex justify-center align-end h-full pb-5">
        <v-btn
          @click="accept()"
          class="border-doubled gold font-size-18 font-weight-superbold text-uppercase px-10"
          v-if="yesVisible"
        >
          {{ yesText }}
        </v-btn>
        <v-btn
          @click="closeDialog()"
          class="border-doubled red-bright font-size-18 font-weight-superbold text-uppercase px-10"
          v-if="noVisible"
        >
          {{ noText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
  .prompt-card {
    padding-left: 80px;
    padding-right: 80px;

    .prompt-title {
      text-wrap: pretty;
      word-break: break-word;
      text-align: center;
    }

    @media (max-width: 600px) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .close-button-white {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 40px;
  }

  .confirm-dialog {
    .v-card {
      .v-icon:not(.close-icon) {
        position: absolute;
        right: 15px;
        top: 10px;
      }
    }
  }

  .double-border {
    border-radius: 20px;

    &::after {
      content: '';
      position: absolute;
      top: -4px;
      bottom: -4px;
      left: -4px;
      right: -4px;
      border-radius: 35px;
    }

    &.gold {
      &::after {
        border: 1px solid var(--v-gold-base);
      }
    }

    &.red-bright {
      &::after {
        border: 1px solid var(--v-red-bright-base);
      }
    }
  }

  .prompt-body::v-deep {
    input,
    input::placeholder {
      color: black !important;
      font-weight: bold;
      font-style: italic;
    }

    .v-input__slot {
      background: #fff !important;
    }
  }
</style>
